import DCCState from "./dcc";
import colorState from "./color";
import errorState from "./error";
import amountState from "./amount";
import campaignState from "./campaign";
import localeState from "./locale";
import methodState from "./method";
import currencyState from "./currency";
import countryState from "./country";
import customerState from "./customer";
import merchantState from "./merchant";
import viewportState from "./viewport";
import processingState from "./processing";
import infoState from "./info";
import testModeState from "./testmode";
import EventLog from "../../logger/events";
import backgroundProcessingState from "./background_processing";
import sessionState from "./session";
import { parentWindow, hasParent, isWindowOpen } from "../../init/window";
import { isFunction, withAccessors, getValueAtPath, withProperties, objectWithAccessors } from "../../utils";
import { CHECKOUT_CLOSE_EVENT } from "../helpers/tokens";
import { $successful } from "../payment";
import Store from "../../context";
import { fetchTranslatedString } from "../../../support/helpers";

import english from "../../../locales/en/init.json"
import french from "../../../locales/fr/init.json"
import portuguese from "../../../locales/pt/init.json"

const reducers = {};
const STATE_ACTIONS_MAP = {};
const EXPOSED_ACTIONS_MAP = {};

function initialize(data, store) {
  const $context = objectWithAccessors({
    actions: () => STATE_ACTIONS_MAP,
    data: () => data,
    dispatch: () => store.dispatch,
  });

  [
    amountState,
    campaignState,
    colorState,
    currencyState,
    countryState,
    customerState,
    DCCState,
    errorState,
    infoState,
    localeState,
    merchantState,
    methodState,
    testModeState,
    viewportState,
    processingState,
    backgroundProcessingState,
    sessionState
  ].forEach(setup => {
    if (isFunction(setup)) {
      const $state = setup.call($context);
      const { NAME, Reducer, actions, exposedActions } = $state;
      const _withAccessors = withAccessors.bind($state);
      
      actions && (STATE_ACTIONS_MAP[NAME] = actions);
      exposedActions && withProperties(EXPOSED_ACTIONS_MAP, exposedActions);

      reducers[NAME] = Reducer;
      
      _withAccessors('STATE', function __stateGetter__() {
        return getValueAtPath(store.getState(), `${NAME}`);
      });
    }
  });

  withProperties(EXPOSED_ACTIONS_MAP, {
    LogUntranslatedErrors: withProperties(Object.create(null), {
      logError(payload) {
        EventLog.logUntranslatedError(payload)
      }
    }),

    Control: withProperties(Object.create(null), {
      close(evt) {
        evt && typeof getValueAtPath(evt, 'preventDefault') === 'function' && evt.preventDefault();

        const currentView = getValueAtPath(Store.getState(), 'view.current');
        const locales = {
          en: english,
          fr: french,
          pt: portuguese
        };

        let canClose = true;
        let currentLocaleFile = locales[getValueAtPath(store.getState(), 'locale')] || english;        
        let languageFileString = 'close.checkout.notice';

        let promptMessage = fetchTranslatedString(currentLocaleFile, languageFileString);

        if (($successful || currentView === 'PENDING_VIEW') && (hasParent || isWindowOpen)) {
          try {
            dispatchEvent(new CustomEvent(CHECKOUT_CLOSE_EVENT, {
              bubbles: false,
              cancelable: false
            }));
            
            EventLog.closeModal(true);

            parentWindow.postMessage({
              name: 'closeiframe',
              data: {}
            }, '*');
          } catch (e) {}

        } else if (!$successful && canClose && confirm(promptMessage) &&  (hasParent || isWindowOpen)) {
          try {
            dispatchEvent(new CustomEvent(CHECKOUT_CLOSE_EVENT, {
              bubbles: false,
              cancelable: false
            }));
            
            EventLog.closeModal();

            parentWindow.postMessage({
              name: 'closeiframe',
              data: { cancelled: true }
            }, '*');
          } catch (e) {}
        }
      }
    })
  });
}

export {
  initialize,
  reducers,
  EXPOSED_ACTIONS_MAP as actions
};
